import { createEnvConfig } from '@talos/kyoko';

export type AVA_ENVS = 'local' | 'develop' | 'staging' | 'uat' | 'alpha' | 'sandbox' | 'prod' | 'test';
// Runtime-configurable environment variables (injectable at Docker startup)
export interface EnvConfig {
  readonly VITE_SESSION_COOKIE: string;
  readonly VITE_AVA_ENV: AVA_ENVS;
  readonly VITE_AVA_API_ENDPOINT: string;
  readonly VITE_API_ENDPOINT: string;
  readonly VITE_AUTH_LOGIN_URL: string;
  readonly VITE_AUTH_LOGOUT_URL: string;
  readonly VITE_MIXPANEL_TOKEN: string;
  readonly VITE_FAVICON: string;
  readonly VITE_RELEASE_NOTES_URL: string;
  readonly VITE_KNOWLEDGE_BASE_URL: string;
  readonly VITE_DATADOG_CLIENT_TOKEN: string;
  readonly VITE_DATADOG_APP_ID: string;
  readonly VITE_DATADOG_PROXY_URL?: string;
  readonly VITE_INTERCOM_APP_ID: string;
  readonly VITE_MIXPANEL_PROXY_URL?: string;
  readonly VITE_SUPPORT_PHONE?: string;
  readonly VITE_AVA_AI_ENDPOINT?: string;
}

export const envConfig = createEnvConfig<EnvConfig>(import.meta.env);
